import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { InputDatepicker } from './interfaces/input-datepicker';
import { Subscription } from 'rxjs';
// import { DispatcherService } from '../../services/dispatcher/dispatcher.service';
import { DateObj } from './interfaces/date-obj';
import { ConfigDate } from './interfaces/configDate';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'app-datepicker_v2',
  templateUrl: './datepicker_v2.component.html',
  styleUrls: ['./datepicker_v2.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => Datepicker_v2Component),
      multi: true,
    },
  ],
})
export class Datepicker_v2Component implements OnInit, ControlValueAccessor, AfterViewInit, OnDestroy, OnChanges {

  //control variable and functions
  dateControl = new FormControl();
  val = ''; // this is the updated value that the class accesses
  onChange: any = () => { };
  onTouch: any = () => { };
  set value(val: any) {
    // this value is updated by programmatic changes
    if (val !== undefined && this.val !== val) {
      this.val = val;
      this.onChange(val);
      this.onTouch(val);
    }
  }
  // this method sets the value programmatically
  writeValue(value: any) {
    this.dateControl.setValue(value);
  }
  // upon UI element value changes, this method gets triggered
  registerOnChange(fn: any) {
    this.dateControl.valueChanges.subscribe(fn);
  }
  // upon touching the element, this method gets triggered
  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }
  setDisabledState(isDisabled: boolean) {
    if (isDisabled) {
      this.dateControl.disable();
    } else {
      this.dateControl.enable();
    }
  }


  //common date picker variable with value
  months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  weekdays = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"];
  timeSeleted: string = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
  year = new Date().getFullYear();
  month = new Date().getMonth();
  today = new Date();
  selectedYear = this.year;
  currentYear = this.year;
  arrayYear = this.yearRangeCal(this.year)
  incheck = false;//for with range variable
  prev = "<"

  //for no Range variable
  activeDate: Date | null = this.today;
  selectedDate: Date | null = this.today;
  //for with range variable
  range: { start: Date | null; end: Date | null } = {
    start: null,
    end: null,
  };

  //for template showing
  showallmonth = false;
  showallyear = false;
  showdays = true;
  showTimer = false;


  @ViewChild('datepicker') datepicker!: ElementRef<HTMLElement>
  days: any[] = []
  // { dateTxt:string,date: Date,day: number,isMonth:boolean,time:any}[][]=[];
  toggle = false;

  seperator: string = 'to';
  dateSeperator: string = '/';
  timeSeperator: string = ' '

  //for range place holder
  startDatePlaceHolder: string = '';
  endDatePlaceHolder: string = '';

  @Input() field!: InputDatepicker;
  @Input() parentId: string = 'datepicker_v2';
  @Input() isInValid: boolean = false;
  @Input() disabled: boolean = false;
  //to disable date (variables)
  @Input() configDate: ConfigDate = {
    minDate: null, //disable dates that comes before this date;
    maxDate: null, //disable dates that comes after this date;
    startDateReadOnly: false, // set start date readonly
    endDateReadOnly: false,  //set the end date readonly
  };
  @Output() valueChange = new EventEmitter<string>();
  dateFormatArr: string[] = [];
  @ViewChild('inputFeildNoRange') inputFeildNoRange!: ElementRef;
  @ViewChild('inputFeildWithRange') inputFeildWithRange!: ElementRef;
  inputFieldArr: HTMLInputElement[] = [];
  inputValues: string[] = [];
  backSpace: number = 0;
  isSaveClicked: boolean = false;
  startDateReadOnly?: boolean;
  endDateReadOnly?: boolean;
  disablePreviousDates: Date | null = null;
  disableFutureDates: Date | null = null;

  //timer varibles
  minuteArr: string[] = [];
  hourSet: string[] = [];
  hour: string = this.addLeadingZero((new Date().getHours() > 12 ? new Date().getHours() % 12 : new Date().getHours()))
  minute: string = this.addLeadingZero(new Date().getMinutes());
  meridiem: string = (new Date().toLocaleTimeString('en-US').split(' ')[1]);
  public subscriptionMap: Record<string, Subscription> = {};


  // private dispatcherService: DispatcherService
  constructor(
    private router: Router,
  ) { }

  ngOnInit() {
    //set sepertor and placeholders
    this.seperator = this.field.seperator ? this.field.seperator : ` to `;
    this.dateSeperator = this.field.dateSeperator ? this.field.dateSeperator : `/`;
    this.timeSeperator = this.field.timeSeperator ? this.field.timeSeperator : ` `;
    if (this.field.startDatePlaceHolder && !this.field.endDatePlaceHolder) {
      this.startDatePlaceHolder = this.endDatePlaceHolder = this.field.startDatePlaceHolder;
    }
    if (this.field.endDatePlaceHolder && !this.field.startDatePlaceHolder) {
      this.endDatePlaceHolder = this.startDatePlaceHolder = this.field.endDatePlaceHolder;
    }
    if (this.field.startDatePlaceHolder && this.field.endDatePlaceHolder) {
      this.startDatePlaceHolder = this.field.startDatePlaceHolder;
      this.endDatePlaceHolder = this.field.endDatePlaceHolder;
    }
    this.days = this.generateDays(this.year, this.month);
    this.onInitTimer();
  }

  onInitTimer() {
    if (this.field.timer) {
      this.minuteArr = Array.from({ length: 60 }, (_, i) => this.addLeadingZero(i));
      this.hourSet = this.field.hourFormat == 24 ? Array.from({ length: 24 }, (_, i) => this.addLeadingZero(i)) : Array.from({ length: 12 }, (_, i) => this.addLeadingZero(i + 1));
      this.timeSeleted = this.defaultTime();
    }
  }

  setValidators() {
    let Validatorsarr: any[] = []
    if (this.field.required) {
      Validatorsarr.push(Validators.required)
    }
    if (this.field.regularExpression) {
      Validatorsarr.push(Validators.pattern(this.field.regularExpression))
    }
    if (Validatorsarr.length) {
      this.dateControl.setValidators(Validatorsarr)
    }
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['configDate'] && !changes['configDate'].firstChange) {
      this.disablePreviousDates = null;
      this.disableFutureDates = null;
      this.startDateReadOnly = false;
      this.endDateReadOnly = false;
      this.disableDates();
    }
  }
  disableDates() {
    this.disablePreviousDates = this.configDate.minDate != null ? new Date(this.configDate.minDate) : null;
    this.disableFutureDates = this.configDate.maxDate != null ? new Date(this.configDate.maxDate) : null;
    this.startDateReadOnly = this.configDate.startDateReadOnly;
    this.endDateReadOnly = this.configDate.endDateReadOnly;
    if (this.activeDate && ((this.disablePreviousDates &&
      this.activeDate.getTime() < this.disablePreviousDates.getTime()) ||
      (this.disableFutureDates && this.activeDate.getTime() > this.disableFutureDates.getTime()))) {
      this.clickClear();
    }
  }

  ngAfterViewInit(): void {
    if (this.inputFeildNoRange && this.inputFeildNoRange.nativeElement) {
      this.inputFieldArr = this.inputFeildNoRange.nativeElement.querySelectorAll('input');
    }
    if (this.inputFeildWithRange && this.inputFeildWithRange.nativeElement) {
      this.inputFieldArr = this.inputFeildWithRange.nativeElement.querySelectorAll('input');
    }
  }

  public generateDays(year: number, month: number) {
    const increment = this.getIncrement(year, month)
    const days: any = [];
    [0, 1, 2, 3, 4, 5,].forEach((x, index) => {
      days.push([])
      for (let y = 0; y < 7; y++) {
        const date = this.getDate(x, y, year, month, increment)
        days[index].push(date)
      }
    })
    return days
  }

  public getIncrement(year: number, month: number): number {
    let date = new Date(year + "-" + (month + 1));
    let increment = date.getDay() > 0 ? date.getDay() - 1 : 6;
    return increment;
  }

  public getDate(
    week: number,
    dayWeek: number,
    year: number,
    month: number,
    increment: number
  ) {
    let date: any;
    let day = week * 7 + dayWeek - increment;
    if (day <= 0) {
      let fechaAuxiliar = new Date(year + "-" + (month + 1));
      date = new Date(
        fechaAuxiliar.getTime() + (day - 1) * 24 * 60 * 60 * 1000
      );
    } else {
      date = new Date(year + "-" + (month + 1) + "-" + day + '00:00:00');
      if (isNaN(date.getTime())) {
        let fechaAuxiliar = new Date(year + "-" + (month + 1))
        date = new Date(
          fechaAuxiliar.getTime() + (day - 1) * 24 * 60 * 60 * 1000
        );
      }
    }
    return {
      dateTxt: date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2),
      date: date,
      day: date.getDate(),
      isMonth: this.status(date, month),
      time: date.getTime()
    };
  }

  status(date: Date, month: number) {
    if (month > 0 && month < 11) {
      return date.getMonth() !== month - 1 && date.getMonth() !== month + 1;
    } else {
      return date.getMonth() === month;
    }
  }

  checkEventPathForClass(path: any, selector: any): boolean {
    return path.some((p: any) => p.classList && p.classList.contains(selector));
  }

  setDate(value: string) {
    return (value.split(this.field.dateSeperator).reverse().join('-') + ' 0:0:0')
  }

  inputClick() {
    this.toggle = !this.toggle;
    if (this.toggle) {
      this.showdays = true;
      this.showallmonth = this.showallyear = this.showTimer = false;
      document.body.style.overflow = 'hidden';
      document.body.appendChild(this.datepicker.nativeElement);
      this.datepicker.nativeElement.focus();
      this.activeDate = null;
      if (this.field.range) {
        this.setActiveDateRanges();
      } else {
        this.setActives();
      }
      if (!this.activeDate) {
        this.activeDate = new Date();
        this.timeSeleted = this.defaultTime();
      }
      this.year = this.activeDate.getFullYear();
      this.month = this.activeDate.getMonth();
      this.days = this.generateDays(this.year, this.month);
      this.selectedDate = this.activeDate; //store seleted date as new date()
      this.eventListenerSetting();
      // check weather the range start is already selected.
      if (this.range.start && !this.range.end) {
        this.incheck = true;
      }
      this.subscriptionMap['routerSub'] = this.router.events.subscribe(event => {
        if ((event instanceof NavigationEnd || event instanceof NavigationStart) && (this.datepicker?.nativeElement).innerHTML.replace(/<!--[\s\S]*?-->/g, '').trim().length !== 0) {
          this.removingDatepicker()
        }
      })
    }
  }
  eventListenerSetting() {
    const clickListener = (event: Event) => {
      event.stopPropagation();
      if (!this.checkEventPathForClass(event.composedPath(), 'datepicker')) {
        if (document.body.contains(this.datepicker.nativeElement)) {
          this.removingDatepicker();
          if (this.field.range) {
            this.setActiveDateRanges();
          } else {
            this.setActives();
          }
          this.showallmonth = false;
          this.showdays = true;
          this.showallyear = false;
          this.showTimer = false;
          this.datepicker.nativeElement.removeEventListener('click', clickListener);
          this.incheck = false;
        }
      }
    }
    this.datepicker.nativeElement.addEventListener('click', clickListener);
  }

  setActives() {
    const separator = this.field.dateSeperator || '/';
    if (this.field.dateFormat && this.dateControl.value) {
      const dateArr = this.dateControl.value.split(this.timeSeperator)[0].split(separator);
      const formatDateArr = this.field.dateFormat.toLowerCase().split(separator);
      if (dateArr.length > 1 && formatDateArr.length > 1) {
        const dateObj: DateObj = formatDateArr.reduce((acc: DateObj, format: string, index: number) => {
          const key = format as keyof DateObj;
          acc[key] = +dateArr[index];
          return acc;
        }, { dd: NaN, mm: NaN, yyyy: NaN });
        if (!isNaN(dateObj.dd) && !isNaN(dateObj.mm) && !isNaN(dateObj.yyyy)) {
          this.activeDate = new Date(`${dateObj.yyyy}-${dateObj.mm}-${dateObj.dd} 0:0:0`);
        }

        if (this.field.timer) {
          this.setTimerValueControl();
        }
      }
    }
    else if (!this.dateControl.value) {
      this.timeSeleted = this.defaultTime();
    }
  }

  dummyActives() {
    const separator = this.field.dateSeperator || '/';
    this.activeDate = null;
    if (this.field.dateFormat && this.dateControl.value) {
      const dateArr = this.dateControl.value.split(this.timeSeperator)[0].split(separator);
      const formatDateArr = this.field.dateFormat.toLowerCase().split(separator);
      if (dateArr.length > 1 && formatDateArr.length > 1) {
        const dateObj: DateObj = formatDateArr.reduce((acc: DateObj, format: string, index: number) => {
          const key = format as keyof DateObj;
          acc[key] = +dateArr[index];
          return acc;
        }, { dd: NaN, mm: NaN, yyyy: NaN });
        if (!isNaN(dateObj.dd) && !isNaN(dateObj.mm) && !isNaN(dateObj.yyyy)) {
          return new Date(`${dateObj.yyyy}-${dateObj.mm}-${dateObj.dd} 0:0:0`);
        }
      }
    }
    return
  }

  setActiveDateRanges() {
    if (this.dateControl.value) {
      const dates: string[] = this.dateControl.value.split(this.seperator);
      let startDate = this.dateFromatSet(dates[0]);
      let endDate = this.dateFromatSet(dates[1]);
      if (startDate) {
        this.range.start = startDate;
      } else {
        this.range.start = null;
      }
      if (endDate) {
        this.range.end = endDate;
      } else {
        this.range.end = null;
      }
      //for reopen the datepicker its automatically navigate to last selected date
      if (endDate) {
        this.activeDate = endDate
      } else if (startDate) {
        this.activeDate = startDate
      }

    } else {
      this.range.start = this.range.end = null;
    }
  }
  // returns the start date and end date from the control value;
  dateFromatSet(value: string): Date | undefined {
    let dateArr = value.split(this.dateSeperator);
    let formatDateArr = this.field.dateFormat.toLocaleLowerCase().split(this.dateSeperator);
    let day = NaN;
    let month = NaN;
    let year = NaN;
    dateArr.forEach((ele: string, index: number) => {
      if (formatDateArr[index] == 'yyyy') {
        year = +ele
      }
      if (formatDateArr[index] == 'mm') {
        month = +ele
      }
      if (formatDateArr[index] == 'dd') {
        day = +ele
      }
    })
    if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
      return new Date(`${year}-${month}-${day} 0:0:0`)
    } else {
      return
    }
  }

  prevMonth() {
    if (this.disablePreviousDates && this.month <= this.disablePreviousDates.getMonth() && (this.year <= this.disablePreviousDates.getFullYear())) {
      return;
    } else {
      if (this.month > 0) {
        this.month = this.month - 1;
      } else {
        this.month = 11
        this.year -= 1
      }
      this.days = this.generateDays(this.year, this.month);
      this.activeDateSetting();
    }
  }

  setDaysClass(day: any): string {
    let returnClass = '';
    const isDisabled =
      (this.disablePreviousDates && (day.date.setHours(0, 0, 0, 0) < this.disablePreviousDates.setHours(0, 0, 0, 0))) ||
      (this.disableFutureDates && (day.date.setHours(0, 0, 0, 0) > this.disableFutureDates.setHours(0, 0, 0, 0)));
    const isMuted = !day.isMonth;
    const isToday = day.date.toLocaleDateString() === this.today.toLocaleDateString();
    const selected = day.date.toLocaleDateString() === (this.selectedDate?.toLocaleDateString());
    const prevDay = day.date.toLocaleDateString() === (this.activeDate?.toLocaleDateString());
    if (selected) {
      returnClass += ` selected  ${this.field.selectedDateClassName ? this.field.selectedDateClassName as string : ' '}`
    }
    if (isDisabled) {
      returnClass += ' disable';
    }
    if (isMuted) {
      returnClass += ' muted';
    }
    if (prevDay && !(isToday || selected)) {
      returnClass += ` previous ${this.field.previousClassName ? this.field.previousClassName : ''}`;
    }
    if (isToday) {
      returnClass += ` today ${this.field.todayClassName ? this.field.todayClassName : ''}`
    }
    return returnClass;
  }

  getClass(day: any) {
    if (this.field.range) {
      return {
        selected: (this.range.start !== null && day.date.toLocaleDateString() == this.range.start.toLocaleDateString()) || (this.range.end !== null && day.date.toLocaleDateString() == this.range.end.toLocaleDateString()),
        daybetween: (this.range.start !== null && this.range.end !== null) && (day.date > this.range.start && day.date < this.range.end),
        today: day.date.toLocaleDateString() == this.today.toLocaleDateString(),
        disable: (this.disablePreviousDates &&
          (day.date.setHours(0, 0, 0, 0) < this.disablePreviousDates.setHours(0, 0, 0, 0)) ||
          this.disableFutureDates &&
          (day.date.setHours(0, 0, 0, 0) > this.disableFutureDates.setHours(0, 0, 0, 0))
        ),
        muted: !day.isMonth,

      };
    } else {
      return this.setDaysClass(day);
    }
  }

  monthSelected(e: Event) {
    if (!this.showallmonth) {
      this.showallmonth = true;
      this.showdays = false;
      this.showallyear = false;
      this.showTimer = false;
    } else {
      this.changeMonth(this.month);

    }
  }

  selectYear(e: Event) {
    if (!this.showallyear) {
      this.showallmonth = false;
      this.showdays = false;
      this.showallyear = true;
      this.showTimer = false;
    } else {
      this.changeYear(this.year);
    }

  }

  nextMonth() {
    if (this.disableFutureDates && this.month >= this.disableFutureDates.getMonth() && (this.year >= this.disableFutureDates.getFullYear())) {
      return;
    } else {
      if (this.month < 11) {
        this.month = this.month + 1;
      } else {
        this.month = 0
        this.year += 1
      }
      this.days = this.generateDays(this.year, this.month);
      this.activeDateSetting();
    }
  }

  selectDay(day: any) {
    const date = new Date(day.dateTxt + ' 0:0:0')
    if ((this.disablePreviousDates && date < this.disablePreviousDates) || (this.disableFutureDates && date > this.disableFutureDates)) {
      return;
    }
    else {
      if (this.field.range) {
        this.selectRangeDate(day);
      } else {
        this.activeDate = new Date(day.dateTxt + ' 0:0:0');
        this.year = this.activeDate.getFullYear();
        this.month = this.activeDate.getMonth()
        if (!day.isMonth) {
          this.days = this.generateDays(this.year, this.month);
        }
        this.days = this.generateDays(this.year, this.month)
      }
    }

  }

  removingDatepicker() {
    if (document.body.contains(this.datepicker.nativeElement)) {
      // event.preventDefault();
      document.body.removeChild(this.datepicker.nativeElement)
      document.body.style.overflow = '';
      this.toggle = false;
      this.subscriptionMap['routerSub']?.unsubscribe();
    }
  }
  ClickOk(event: Event) {
    if (document.body.contains(this.datepicker.nativeElement)) {
      this.removingDatepicker();
      if (this.field.range) {
        //range logic
        const language = this.field.locale ? this.field.locale : window.navigator.language;
        const options = this.field.options
        let selectedDates = this.valueFormat(language, options);
        let formatArr = ['d', 'm', 'y']
        if (selectedDates && !formatArr.includes(selectedDates[0].toLocaleLowerCase())) {
          this.dateControl.setValue(selectedDates);
        }
      } else {
        if (this.activeDate) {
          if (!this.field.timer) {
            this.dateControl.setValue(this.transform(this.activeDate));
          } else {
            let selectedDate: string = this.transform(this.activeDate);
            this.selectedDate = this.activeDate; //store seleted date as new date()
            this.dateControl.setValue(`${selectedDate}${this.timeSeperator}${this.timeSeleted}`)
          }
        } else {
          if (this.field.timer) {
            this.timeSeleted = this.defaultTime();
          }
        }
      }
    }
  }

  clickCancle(event: Event) {
    if (document.body.contains(this.datepicker.nativeElement)) {
      this.removingDatepicker();
      this.activeDate = null;
      // this.incheck = this.range.start?false:true;
      this.incheck = false;
    }
  }

  selectRangeDate(day: any) {
    this.range.end = null;
    if (!this.incheck) {
      this.range.start = new Date(day.dateTxt + ' 0:0:0');
      this.incheck = true;
    } else {
      let dummydate = new Date(day.dateTxt + ' 0:0:0');
      this.range.end = new Date();
      if (this.range.start !== null && this.range.end !== null) {
        let range = Math.floor(
          (dummydate.getTime() - this.range.start.getTime()) / 86400000); //(1000/60/60/24) time divison
        if (range >= 0) {
          this.range.end = new Date(day.dateTxt + ' 0:0:0');
          this.incheck = false;
        } else {
          this.range.start = new Date(day.dateTxt + ' 0:0:0');
          this.range.end = null;
          this.incheck = true;
        }
      }
    }
  };

  valueFormat(language: string, options: any, year?: boolean) {
    const startDateStr = ((year && this.range.start) ? this.range.start.toLocaleDateString(language, options) + ' ' + this.range.start.getFullYear() : this.range.start?.toLocaleDateString(language, options)) ?? '';
    const endDateStr = ((year && this.range.end) ? this.range.end.toLocaleDateString(language, options) + ' ' + this.range.end.getFullYear() : this.range.end?.toLocaleDateString(language, options)) ?? '';
    if (startDateStr && endDateStr) {
      return `${startDateStr}${this.seperator}${endDateStr}`;
    } else if (this.endDatePlaceHolder.length) {
      return startDateStr ? `${startDateStr}${this.seperator}${this.endDatePlaceHolder}` : this.setPlaceHolder();
    } else {
      return startDateStr ? `${startDateStr}${this.seperator}` : '';
    }
  }

  clickClear() {
    this.dateControl.reset();
    if (this.field.range) {
      this.range.start = this.range.end = null;
      this.incheck = false;
    } else {
      this.activeDate = null;
      this.timeSeleted = this.defaultTime();
    }
  }

  transform(value: Date): string {
    if (this.field.locale != undefined) {
      return value.toLocaleDateString(this.field.locale, this.field.options)
    } else {
      let language = window.navigator.language;
      return value.toLocaleDateString(language, this.field.options)
    }
  }

  setPlaceHolder(): string {
    if (this.field.range) {
      if (this.startDatePlaceHolder && this.endDatePlaceHolder) {
        return `${this.startDatePlaceHolder} ${this.seperator} ${this.endDatePlaceHolder}`;
      } else {
        return '';
      }
    } else {
      return this.field.placeholder ? this.field.placeholder : 'DD/MM/YYYY'
    }
  }

  changeMonth(i: number) {
    if ((this.disablePreviousDates && (i < this.disablePreviousDates.getMonth())) &&
      (this.year <= this.disablePreviousDates.getFullYear()) ||
      (this.disableFutureDates && (i > this.disableFutureDates.getMonth())) &&
      (this.year >= this.disableFutureDates.getFullYear())) {
      return;
    } else {
      this.month = i
      this.days = this.generateDays(this.year, this.month)
      this.activeDateSetting()
      this.showallmonth = false;
      this.showdays = true;
      this.showTimer = false;
    }
  }

  activeDateSetting() {
    if (this.activeDate) {
      let day = this.activeDate.getDate()
      this.activeDate = new Date(`${this.year}-${this.month + 1}-${day}` + ' 0:0:0')
    }
  }

  yearRangeCal(n: number) {
    n = n <= 24 ? 12 : n;
    return Array.from({ length: 24 }, (_, i) => n - 11 + i);
  }

  prevYear() {
    if (this.disablePreviousDates && this.arrayYear[0] < this.disablePreviousDates.getFullYear()) {
      return;
    } else {
      this.arrayYear = this.yearRangeCal(this.selectedYear <= 24 ? this.selectedYear = 12 : this.selectedYear -= 24)
    }
  }

  nextYear() {
    if (this.disableFutureDates && this.arrayYear[23] > this.disableFutureDates.getFullYear()) {
      return;
    } else {
      this.arrayYear = this.yearRangeCal(this.selectedYear += 24)
    }
  }

  changeYear(year: number) {
    if (this.disablePreviousDates && (year < this.disablePreviousDates.getFullYear()) || this.disableFutureDates && (year > this.disableFutureDates.getFullYear())) {
      return;
    } else {
      this.selectedYear = this.year = year;
      this.activeDateSetting()
      this.showallmonth = true;
      this.showdays = false;
      this.showallyear = false;
      this.showTimer = false;
    }
  }

  setShowRange(): string {
    const language = this.field.locale ? this.field.locale : window.navigator.language;
    const options = { weekday: 'short', month: 'short', day: '2-digit' }
    return this.valueFormat(language, options, true);
  }

  getMonthClass(i: number) {
    let returnClass = '';
    const isDisabled = (this.disablePreviousDates &&
      (i < this.disablePreviousDates.getMonth() && (this.year <= this.disablePreviousDates.getFullYear())) ||
      this.disableFutureDates &&
      (i > this.disableFutureDates.getMonth() && (this.year >= this.disableFutureDates.getFullYear()))
    )
    const isToday = i === new Date().getMonth() && this.year == new Date().getFullYear();
    const selected = i === this.month && (this.year === this.selectedDate?.getFullYear());
    const prevMonth = i === this.month && this.year === this.activeDate?.getFullYear();

    if (selected) {
      this.field.selectedDateClassName ? returnClass += ('selected ' + this.field.selectedDateClassName) : returnClass += 'selected';
    }
    if (isDisabled) {
      returnClass += ' disable';
    }
    if (isToday) {
      this.field.todayClassName ? returnClass += (' today ' + this.field.todayClassName) : returnClass += ' today';
    }
    if (prevMonth && !(isToday || selected)) {
      this.field.previousClassName ? returnClass += (' previous ' + this.field.previousClassName) : returnClass += ' previous';
    }

    return returnClass;
  }

  getYearClass(year: number) {
    return {
      selected: year === this.year,
      today: year === this.currentYear,
      disable: (this.disablePreviousDates &&
        (year < this.disablePreviousDates.getFullYear()) ||
        this.disableFutureDates &&
        (year > this.disableFutureDates.getFullYear())
      ),
    };
  }

  isValidPattern() {
    return this.dateControl?.hasError('pattern');
  }

  isValidRequired() {
    return this.dateControl?.hasError('required');
  }

  idCheck(passingId: string) {
    let arr = this.idArrayCreation();
    if (arr) {
      if (arr.join('.') == passingId) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  idArrayCreation() {
    let a: any[] = this.parentId.split('.');
    let b: any[] = [];
    for (let i = 0; i < a.length; i++) {
      if (!isNaN(+a[i])) {
        b.push("*");
      } else {
        b.push(a[i]);
      }
    }
    return b;
  }
  addLeadingZero(number: number): string {
    return number < 10 ? '0' + number : number.toString();
  }
  // combine the date with time to show;
  setActiveDateWithTime(): string {
    if (this.activeDate) {
      let curentDate = this.activeDate?.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: '2-digit' });
      return `${curentDate}${this.timeSeperator}${this.timeSeleted}`
    } else {
      return ``
    }
  }
  //set a defaut timer values;
  defaultTime(): string {
    let currentDate = new Date()
    this.hour = this.addLeadingZero((currentDate.getHours() > 12 ? currentDate.getHours() % 12 : currentDate.getHours()))
    this.minute = this.addLeadingZero(currentDate.getMinutes());
    this.meridiem = (currentDate.toLocaleTimeString('en-US').split(' ')[1]);
    if (this.field.hourFormat == 24) {
      return currentDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
    } else {
      return currentDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
    }
  }

  toggleTimer() {
    if (!this.showTimer) {
      this.showTimer = true;
      this.showallmonth = false;
      this.showdays = false;
      this.showallyear = false;
    } else {
      this.showTimer = false;
      this.showallmonth = false;
      this.showdays = true;
      this.showallyear = false;
    }
  }
  //set the time format to show
  setTimer(): void {
    if (this.field.hourFormat != 24) {
      this.timeSeleted = `${this.hour}:${this.minute} ${this.meridiem}`;
    } else {
      this.timeSeleted = `${this.hour}:${this.minute}`;
    }
  }

  meridiemChange(event: any) {
    this.meridiem = event.target.value;
    this.setTimer();
  }

  minChange(event: any) {
    this.minute = event.target.value;
    this.setTimer();
  }

  HourChange(event: any) {
    this.hour = event.target.value;
    this.setTimer();
  }
  //set the timer value from the formcontrol value;
  setTimerValueControl() {
    const dateTime = this.dateControl.value;
    const dateTimeArr: string[] = dateTime.split(this.timeSeperator).filter((element: string) => element !== '');
    const timeSelected: string = dateTimeArr[1].trim();
    const [hour, minute]: string[] = timeSelected.split(':');
    let meridiem = '';
    if (!this.field.hourFormat) {
      meridiem = dateTimeArr[2].trim();
    }

    this.timeSeleted = `${timeSelected} ${meridiem}`
    this.hour = hour;
    this.minute = minute;
    this.meridiem = meridiem;

  }

  selectRangeCheck() {
    if (this.field?.range && this.range.start && !this.range.end) {
      return true
    }
    if (this.field?.range && !this.range.start && this.range.end) {
      return true
    }
    return false
  }

  ngOnDestroy(): void {
    for (let key in this.subscriptionMap) {
      if (this.subscriptionMap[key]) this.subscriptionMap[key].unsubscribe();
    }
  }

}
